function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useRef, useState } from 'react';
import { Button } from '@naf/button';
import { TextVariant } from '@naf/text';
import * as S from './campaignBannerStyles';
export let CampaignBannerVariant = /*#__PURE__*/function (CampaignBannerVariant) {
  CampaignBannerVariant["Small"] = "small";
  CampaignBannerVariant["Medium"] = "medium";
  CampaignBannerVariant["Large"] = "large";
  return CampaignBannerVariant;
}({});
export let CampaignBannerColor = /*#__PURE__*/function (CampaignBannerColor) {
  CampaignBannerColor["Yellow20"] = "yellow20";
  CampaignBannerColor["Dew"] = "dew";
  return CampaignBannerColor;
}({});
export const CampaignBanner = /*#__PURE__*/forwardRef(({
  variant = CampaignBannerVariant.Medium,
  color = CampaignBannerColor.Yellow20,
  label,
  title,
  ctaButton,
  secondaryButton,
  advancedImage,
  img,
  illustration,
  children,
  showDiscountCopy,
  ...rest
}, ref) => {
  const [renderedImageHeight, setRenderedImageHeight] = useState(0);
  const resizeObserverRef = useRef(null);
  const imageRefCallback = node => {
    if (node) {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          setRenderedImageHeight(entry.target.clientHeight);
        }
      });
      resizeObserver.observe(node);
      resizeObserverRef.current = resizeObserver;
    } else {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
    }
  };
  const headerVariant = variant => {
    switch (variant) {
      case CampaignBannerVariant.Small:
        return TextVariant.Header2;
      case CampaignBannerVariant.Medium:
        return TextVariant.Header2;
      case CampaignBannerVariant.Large:
        return TextVariant.Header1;
      default:
        return TextVariant.Header2;
    }
  };
  const buttonSize = variant => {
    switch (variant) {
      case CampaignBannerVariant.Small:
        return 'small';
      case CampaignBannerVariant.Medium:
        return 'small';
      case CampaignBannerVariant.Large:
        return 'medium';
      default:
        return 'small';
    }
  };
  const buttonColor = color => {
    switch (color) {
      case CampaignBannerColor.Yellow20:
        return 'signature';
      case CampaignBannerColor.Dew:
        return 'spruce';
      default:
        return 'signature';
    }
  };
  return /*#__PURE__*/React.createElement(S.Container, _extends({
    ref: ref,
    $variant: variant,
    $color: color,
    $img: !illustration,
    $imageHeight: renderedImageHeight
  }, rest), /*#__PURE__*/React.createElement(S.Content, {
    $size: variant
  }, label && /*#__PURE__*/React.createElement(S.Label, {
    $size: variant,
    variant: TextVariant.Tag
  }, label), title && /*#__PURE__*/React.createElement(S.Title, {
    $size: variant,
    variant: headerVariant(variant)
  }, title), /*#__PURE__*/React.createElement(S.Body, null, children), showDiscountCopy && /*#__PURE__*/React.createElement(S.DiscountWrapper, null, showDiscountCopy), (ctaButton || secondaryButton) && /*#__PURE__*/React.createElement(S.Buttons, {
    size: variant
  }, ctaButton && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: ctaButton.href,
    size: buttonSize(variant),
    variant: buttonColor(color),
    onClick: ctaButton.onClick,
    target: ctaButton.blank ? '_blank' : '_self',
    rel: "noreferrer"
  }, ctaButton.text), secondaryButton && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: secondaryButton.href,
    size: buttonSize(variant),
    variant: "outline",
    onClick: secondaryButton.onClick,
    target: secondaryButton.blank ? '_blank' : '_self',
    rel: "noreferrer"
  }, secondaryButton.text))), (img || advancedImage) && /*#__PURE__*/React.createElement(S.ImageWrapper, {
    $illustration: illustration,
    $imageHeight: renderedImageHeight,
    $size: variant,
    ref: imageRefCallback,
    $objectFit: img?.objectFit
  }, advancedImage ? advancedImage : img && /*#__PURE__*/React.createElement("img", {
    src: img.src,
    alt: img.alt
  })));
});
//# sourceMappingURL=campaignBanner.js.map